export default "__VITE_ASSET__BNxGHvjQ__"